/**
 *  sidebar_map.js
 *
 *  Created by Satoshi Ishizu
 *  Copyright tateoki Inc. All rights reserved.
 */
"use strict";

import * as util from "./util";
import * as constants from "./constants";

/**
 * カテゴリ Sidebar Map オブジェクト定義です
 */
class SidebarMapModel {
  /**
   * コンストラクタです
   * @param {NodeListOf<DivElement>} categoriesElement
   */
  constructor(categoriesElement) {
    this.treeData = [];

    categoriesElement.forEach((item) => {
      const spineLink = item.querySelector(".category_spine_link");
      const books = Array.from(item.children).find((child) => child.classList.contains("books"));
      const contentsNum = books ? books.dataset.contentsNum : 0;
      this.treeData.push({
        id: item.id,
        parent: item.parentNode.classList.contains("main") ? "#" : item.parentNode.id,
        text: spineLink.dataset.displayName + (contentsNum > 0 ? ` (${contentsNum})` : ""),
        data: spineLink.getAttribute("href"),
      });
    });
  }

  /**
   * カテゴリ（多階層）を流し込みます
   * @param {Function} injectedSetInternalDispatchEvent - 内部リンクのイベントディスパッチ関数
   */
  SetCategories(injectedSetInternalDispatchEvent) {
    // jsTree 初期化
    const floormapStructure = document.getElementById("categoriesmap-structure");
    $(floormapStructure)
      .jstree({
        core: {
          data: this.treeData,
          themes: {
            dots: false, // ノード間の点を非表示
            icons: false,
            responsive: false,
          },
          dblclick_toggle: false,
        },
        plugins: ["wholerow"], // 行全体をクリック可能へ
      })
      .on("ready.jstree", function () {
        // サイドバーマップ初期表示
        const loadCategoryId = document.querySelector(".categories").getAttribute("load-category-id");
        if (!loadCategoryId) return;

        const category = document.querySelector(`[data-category-id="${loadCategoryId}"]`);
        if (!category) return;

        openToNode(category.id);
      });

    // ワンクリックでノードを開閉
    floormapStructure.addEventListener("click", function (e) {
      const target = e.target.closest(".jstree-anchor");
      if (target) {
        const instance = $.jstree.reference(target);
        const node = instance.get_node(target);

        // サイドバーマップ部の開閉
        instance.toggle_node(node);

        // カテゴリの状態取得
        const spinLink = document.querySelector(`.category_spine_link[href="${node.data}"]`);
        const isOpen = util.isOpenCategory(spinLink.parentElement);
        const handler = injectedSetInternalDispatchEvent(spinLink, false);

        // サイドバーマップとカテゴリの連動処理
        if (instance.is_closed(node)) {
          // サイドバーマップが閉じたらカテゴリも閉じる
          if (isOpen) spinLink?.click();
        } else {
          // サイドバーマップが開いたらカテゴリも開く
          handler(new Event("click"));
        }
      }
    });
  }

  /**
   * サイドバーマップ UI（ポップアップ）のハンドルを設定します
   */
  SetSidebarToggleHandlers() {
    const categoriesmapElement = document.getElementById("categoriesmap-structure");
    const historymapElement = document.getElementById("historymap-structure");
    const openSidebarCategoriesBtn = document.getElementById("open-categories");
    const openSidebarHistoryBtn = document.getElementById("open-history");
    const closeSidebarBtn = document.getElementById("close-sidebar");
    const sidebar = document.getElementById("sidebar");
    const moveBtnRightArrow = document.querySelector("#move-btn .right-arrow");

    const categoriesText = openSidebarCategoriesBtn.querySelector(".tab-top");
    const historyText = openSidebarHistoryBtn.querySelector(".tab-top");

    function openSidebar(type) {
      sidebar.classList.add("active");
      moveBtnRightArrow.classList.add("hidden");

      if (type === "categories") {
        openSidebarCategoriesBtn.classList.add("selected-btn");
        categoriesText.textContent = "閉じる";
        categoriesmapElement.parentElement.classList.remove("hidden");
        historymapElement.parentElement.classList.add("hidden");
        openSidebarHistoryBtn.classList.remove("selected-btn");
        historyText.textContent = "履歴";
      } else if (type === "history") {
        openSidebarHistoryBtn.classList.add("selected-btn");
        historyText.textContent = "閉じる";
        historymapElement.parentElement.classList.remove("hidden");
        categoriesmapElement.parentElement.classList.add("hidden");
        openSidebarCategoriesBtn.classList.remove("selected-btn");
        categoriesText.textContent = "本棚一覧";
      }
    }

    function closeSidebar() {
      sidebar.classList.remove("active");
      moveBtnRightArrow.classList.remove("hidden");

      openSidebarCategoriesBtn.classList.remove("selected-btn");
      categoriesText.textContent = "本棚一覧";

      openSidebarHistoryBtn.classList.remove("selected-btn");
      historyText.textContent = "履歴";
    }

    openSidebarCategoriesBtn.addEventListener("click", () => {
      if (openSidebarCategoriesBtn.classList.contains("selected-btn")) {
        closeSidebar();
      } else {
        openSidebar("categories");
      }
    });

    openSidebarHistoryBtn.addEventListener("click", () => {
      if (openSidebarHistoryBtn.classList.contains("selected-btn")) {
        closeSidebar();
      } else {
        openSidebar("history");
      }
    });

    closeSidebarBtn.addEventListener("click", closeSidebar);
  }
}

/**
 * サイドバーマップインスタンスを取得します
 * @returns
 */
function getJstreeInstance() {
  const categoriesmapStructure = document.getElementById("categoriesmap-structure");
  if (!categoriesmapStructure) return;
  return $.jstree.reference(categoriesmapStructure);
}

/**
 * ノードクリック状態を示すクラスを付与・解除します
 * @param {string} nodeId - 対象ノードの ID
 */
function addClickedClass(nodeId) {
  const jstreeInstance = getJstreeInstance();
  const nodeElement = jstreeInstance?.get_node(nodeId, true);

  if (nodeElement && nodeElement.length > 0) {
    // nodeElement 配下の aria-selected 属性を持つすべての要素を取得
    const selectedElements = nodeElement[0].querySelectorAll("[aria-selected='true']");

    // それぞれの要素の aria-selected を false に設定
    selectedElements.forEach((el) => el.setAttribute("aria-selected", "false"));

    // jstree-wholerow-clicked と jstree-clicked の両方を持つ要素を取得
    const elements = document.querySelectorAll(".jstree-wholerow-clicked, .jstree-clicked");

    // それぞれの要素からクラスを削除
    elements.forEach((el) => {
      el.classList.remove("jstree-wholerow-clicked", "jstree-clicked");
    });

    // クリック対象のノードを選択状態へ
    const selectedElement = nodeElement[0].querySelector("[aria-selected='false']");
    selectedElement.setAttribute("aria-selected", "true");
    selectedElement.classList.add("jstree-clicked");

    // jstree-wholerow-clicked クラスを付与
    const wholerowElement = nodeElement[0].querySelector(".jstree-wholerow");
    wholerowElement.classList.add("jstree-wholerow-clicked");
  }
}

/**
 * 指定したノードまですべて展開します
 * @param {string} nodeId - 対象ノードの ID
 */
export function openToNode(nodeId) {
  const jstreeInstance = getJstreeInstance();
  if (!jstreeInstance) return;

  const node = jstreeInstance.get_node(nodeId);
  if (!node) return;

  const nodeParents = node.parents;
  if (!nodeParents || nodeParents.length === 0) return;

  // 親階層を順次開く
  nodeParents
    .filter((parentId) => parentId !== "#")
    .reverse()
    .forEach((parentId) => jstreeInstance.open_node(parentId));

  // 指定のノードを開く
  jstreeInstance.open_node(nodeId);

  // 中央位置へのアニメーション移動
  scrollToCenter(nodeId);
}

/**
 * 指定したノードとその配下のすべての子ノードを閉じます
 * @param {string} nodeId - 対象ノードの ID
 */
export function closeAllChildren(nodeId) {
  const jstreeInstance = getJstreeInstance();
  const node = jstreeInstance?.get_node(nodeId);

  if (!node) return;

  // 配下のすべてのノードを再帰的に閉じる
  function closeRecursively(currentNode) {
    jstreeInstance.close_node(currentNode); // ノードを閉じる

    // 子ノードがあれば再帰的に処理
    currentNode.children.forEach((childId) => {
      const childNode = jstreeInstance.get_node(childId);
      if (childNode) closeRecursively(childNode);
    });
  }

  addClickedClass(nodeId);
  closeRecursively(node); // 指定ノードから再帰的に閉じる
}

/**
 * 指定された要素が中央位置となるようにスクロールアニメーションを実行します
 * @param {string} nodeId - 対象ノードの ID
 */
export function scrollToCenter(nodeId) {
  const jstreeInstance = getJstreeInstance();
  const nodeElement = jstreeInstance?.get_node(nodeId, true);

  if (!nodeElement && nodeElement.length > 0) return;

  // 移動量の算出
  const container = document.getElementById("sidebar").querySelector(".list-unstyled");
  const containerHeight = container.clientHeight;
  const elementHeight = nodeElement[0].clientHeight;
  const elementOffsetTop = nodeElement[0].offsetTop;

  // 中央位置を計算
  const scrollPosition = elementOffsetTop - containerHeight / 2 + elementHeight * 2;

  // 選択状態の設定
  addClickedClass(nodeId);

  // スクロールアニメーション実行
  container.scrollTo({
    top: scrollPosition,
    left: 0,
    behavior: "smooth",
  });
}

/**
 * 初期化処理です
 * @param {DivElement} categories - カテゴリ要素の DOM
 * @param {Function} injectedSetInternalDispatchEvent - 内部リンクのイベントディスパッチ関数
 */
export function init(categories, injectedSetInternalDispatchEvent) {
  // サイドバーマップ初期化
  const categoriesFloorMap = new SidebarMapModel(categories);

  // カテゴリ流し込み
  categoriesFloorMap.SetCategories(injectedSetInternalDispatchEvent);

  // サイドバーマップ UI のハンドル設定
  categoriesFloorMap.SetSidebarToggleHandlers();
}
